import { Moment } from 'moment/moment';
import moment from 'moment-timezone';

export class OrderHelpers {
  public static formatPickupTime(time: string | Moment): string {
    const _time = typeof time === 'string' ? moment(time) : time;

    return _time.isSame(moment(), 'day')
      ? `Today at ${_time.format('HH:mm')}`
      : _time.format('dddd, DD MMMM HH:mm');
  }
}
